import { capitalizeFirstLetter } from '../../utils/letters'
function Contact({ configData, isLoading }) {
    // FIX: Extraemos el dato correctamente
    const config = Array.isArray(configData) ? configData[0] : configData;

    return (
        <>
            <section className="tittle-contact">
                <div className="tittle-news-right">
                    <div className="div-news">
                        <span>Datos de Contacto</span>
                        <i className="ri-contacts-fill contact-icon"></i>
                    </div>
                    <div className="titt-n">
                        <span>Contacto</span>
                    </div>
                </div>
            </section>
            <section className="sec-contact font-n">
                <div className="block-ct">
                    <span className="titt-ct">Canales de Atención</span>
                    <p>Medios por los cuales atendemos sus dudas</p>
                    <section className="section-date-ct">
                        <div className="div-mail">
                            <p>Correos electrónicos</p>
                            <div className="div-inf-mail">
                                <span>Central Somnus</span>
                                <p>{isLoading ? "Cargando..." : config?.contacto_email || "No disponible"}</p>
                            </div>
                        </div>
                        <div className="div-phono-adress">
                            <div className="div-phono">
                                <p>Teléfono</p>
                                <div className="div-p">
                                    <span>Oficina Central</span>
                                    <p>+56 {isLoading ? "Cargando..." : config?.contacto_telefono || "No disponible"}</p>
                                </div>
                            </div>
                            <div className="div-adress">
                                <p>Dirección</p>
                                <div className="div-m">
                                    <span>Iquique</span>
                                    <p>{capitalizeFirstLetter(isLoading ? "Cargando..." : config?.contacto_direccion || "No disponible")}</p>
                                </div>
                            </div>
                        </div>
                        <div className="div-hour">
                            <div className="div-inf-hour">
                                <p>Horario de Trabajo</p>
                                <div className="div-open">
                                    <span>Lun - Vie</span>
                                    <div className="hour-open">
                                        <p>9:00</p>
                                        <hr className="nav-divider-line" />
                                        <p>20:00</p>
                                    </div>

                                </div>
                            </div>
                            <div className="div-inf-hour">
                                <div className="div-close">
                                    <span>Sab - Dom</span>
                                    <p>Cerrado.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
        </>
    )
}
export default Contact;